var account = "Paskyra";
var accountSettings = "Paskyros nustatymai";
var charging = "Įkrovimas";
var contactInfo = "Kontaktinė informacija";
var dashboard = "Prietaisų skydelis";
var home = "Pradžia";
var myProducts = "Mano produktai";
var orderHistory = "Užsakymų istorija";
var paymentMethod = "Mokėjimo būdas";
var profileSettings = "Profilio nustatymai";
var referAndEarn = "Rekomenduokite ir uždirbkite";
var signOut = "Atsijungti";
var lt_LT = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, lt_LT as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
